<div class="w-full bg-[#232323] text-white min-h-screen">
  <!-- Título -->
  <div class="px-4 md:px-16 pt-12 pb-6">
    <h1 class="text-4xl font-extrabold mb-2">
      @if (isAdmSistema) {
        Comissões
      } @else {
        Minhas Comissões
      }
    </h1>
    <p class="text-lg text-white/70">
      @if (isAdmSistema) {
        Visualize e gerencie os pagamentos de comissões dos parceiros
      } @else {
        Acompanhe suas comissões referentes às imobiliárias que utilizaram seu cupom
      }
    </p>
  </div>

  <!-- Filtros -->
  <div class="px-4 md:px-16 pb-6">
    <form [formGroup]="filterForm" class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      <!-- Data Inicial -->
      <mat-form-field class="fuse-mat-dense fuse-mat-rounded">
        <mat-label class="text-white">Data Inicial</mat-label>
        <input matInput [matDatepicker]="inicio" formControlName="dataInicial" placeholder="Data Inicial" class="text-white">
        <mat-datepicker-toggle matSuffix [for]="inicio"></mat-datepicker-toggle>
        <mat-datepicker #inicio></mat-datepicker>
      </mat-form-field>
      
      <!-- Data Final -->
      <mat-form-field class="fuse-mat-dense fuse-mat-rounded">
        <mat-label class="text-white">Data Final</mat-label>
        <input matInput [matDatepicker]="final" formControlName="dataFinal" placeholder="Data Final" class="text-white">
        <mat-datepicker-toggle matSuffix [for]="final"></mat-datepicker-toggle>
        <mat-datepicker #final></mat-datepicker>
      </mat-form-field>

      <!-- Status -->
      <mat-form-field class="fuse-mat-dense fuse-mat-rounded">
        <mat-label class="text-white">Status</mat-label>
        <mat-select formControlName="idStatusComissao" class="text-white">
          @for (status of statusOptions; track status.value) {
            <mat-option [value]="status.value">{{ status.label }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </form>
  </div>

  <!-- Botões de Ação -->
  <div class="px-4 md:px-16 pb-6 flex gap-4 justify-end">
    <button mat-stroked-button class="text-white border-white/30 hover:bg-white/10" (click)="limparFiltros()" type="button">
      <mat-icon svgIcon="heroicons_outline:trash" class="icon-size-5"></mat-icon>
      <span class="ml-2">Limpar</span>
    </button>
    <button mat-flat-button class="bg-[#E4811E] hover:bg-[#d4751a] text-white" (click)="search()" type="button">
      <mat-icon svgIcon="heroicons_outline:magnifying-glass" class="icon-size-5"></mat-icon>
      <span class="ml-2">Pesquisar</span>
    </button>
  </div>

  <!-- Barra de Filtro de Resultado -->
  <div class="px-4 md:px-16 pb-4">
    <div class="bg-zinc-800 rounded-lg border border-zinc-700 px-4 py-2 flex items-center max-w-md">
      <mat-icon svgIcon="heroicons_outline:magnifying-glass" class="icon-size-5 text-white/70"></mat-icon>
      <input [formControl]="filterByNome" class="pl-4 pr-2 py-1 bg-transparent w-full outline-none text-white placeholder:text-white/50"
        [placeholder]="isAdmSistema ? 'Filtrar no resultado...' : 'Filtrar por imobiliária...'" type="search" />
    </div>
  </div>

  <!-- Tabela com Header Fixo -->
  <div class="px-4 md:px-16 pb-10">
    <div class="bg-zinc-900 rounded-xl overflow-hidden border border-zinc-800">
      <div class="overflow-auto" style="max-height: 600px;">
        @if (dataSource.data.length === 0) {
          <div class="flex flex-col items-center justify-center py-16 text-center">
            <div class="w-20 h-20 rounded-full bg-zinc-800 flex items-center justify-center mb-4">
              <mat-icon svgIcon="heroicons_outline:banknotes" class="icon-size-10 text-white/30"></mat-icon>
            </div>
            <h3 class="text-lg font-medium text-white/70">Nenhuma comissão encontrada</h3>
            <p class="text-white/50 mt-1">Utilize os filtros acima para pesquisar comissões</p>
          </div>
        } @else {
          <table mat-table [dataSource]="dataSource" matSort class="w-full">

            <!-- Colunas dinâmicas -->
            <ng-container *ngFor="let column of columns" [matColumnDef]="column.property">
              <th mat-header-cell *matHeaderCellDef class="sticky top-0 z-10 bg-zinc-800 px-4 py-3 text-white font-semibold" mat-sort-header>
                {{ column.label }}
              </th>
              <td mat-cell *matCellDef="let row" class="px-4 py-3 text-white" [ngClass]="column.cssClasses">
                <ng-container [ngSwitch]="column.property">
                  <!-- Coluna de Ações -->
                  <ng-container *ngSwitchCase="'actions'">
                    <button type="button"
                            class="icon-btn w-8 h-8 flex items-center justify-center rounded-full hover:bg-zinc-700 transition-colors"
                            [matMenuTriggerFor]="actionsMenu"
                            (click)="menuComissaoAtiva = row; $event.stopPropagation()">
                      <mat-icon svgIcon="heroicons_outline:ellipsis-vertical" class="icon-size-5"></mat-icon>
                    </button>
                  </ng-container>

                  <!-- Coluna de Status (badge) -->
                  <ng-container *ngSwitchCase="'status'">
                    <span [class]="'px-3 py-1 rounded-full text-xs font-medium ' + getStatusColor(row.idStatusComissao)">
                      {{ getStatusLabel(row.idStatusComissao) }}
                    </span>
                  </ng-container>

                  <!-- Outras colunas -->
                  <ng-container *ngSwitchDefault>
                    <ng-container [ngSwitch]="column.type">
                      <ng-container *ngSwitchCase="'text'">{{ row[column.property] }}</ng-container>
                      <ng-container *ngSwitchCase="'number'">{{ row[column.property] }}</ng-container>
                      <ng-container *ngSwitchCase="'cpfCnpj'">{{ row[column.property] | cpfCnpj }}</ng-container>
                      <ng-container *ngSwitchCase="'phone'">{{ row[column.property] | phoneNumber }}</ng-container>
                      <ng-container *ngSwitchDefault>{{ row[column.property] }}</ng-container>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </td>
            </ng-container>

            <!-- Menu de Ações -->
            <mat-menu #actionsMenu="matMenu">
              <!-- Ação: Ver Comprovante (somente para PAGO) -->
              @if (menuComissaoAtiva && canViewComprovante(menuComissaoAtiva)) {
                <button mat-menu-item (click)="verComprovante()">
                  <mat-icon svgIcon="heroicons_outline:document-text" class="text-blue-400"></mat-icon>
                  <span>Ver Comprovante</span>
                </button>
              }

              <!-- Ação: Realizar Pagamento (somente ADM_SISTEMA e PENDENTE) -->
              @if (menuComissaoAtiva && canRealizarPagamento(menuComissaoAtiva)) {
                <button mat-menu-item (click)="realizarPagamento()">
                  <mat-icon svgIcon="heroicons_outline:banknotes" class="text-green-400"></mat-icon>
                  <span>Realizar Pagamento</span>
                </button>
              }

              <!-- Mensagem quando não há ações disponíveis -->
              @if (menuComissaoAtiva && !canViewComprovante(menuComissaoAtiva) && !canRealizarPagamento(menuComissaoAtiva)) {
                <div class="px-4 py-2 text-white/50 text-sm">
                  Nenhuma ação disponível
                </div>
              }
            </mat-menu>

            <tr mat-header-row *matHeaderRowDef="visibleColumns; sticky: true" class="bg-zinc-800"></tr>
            <tr mat-row *matRowDef="let row; columns: visibleColumns"
                class="hover:bg-zinc-800 cursor-pointer border-b border-zinc-800"></tr>
          </table>
        }
      </div>
      @if (dataSource.data.length > 0) {
        <div class="border-t border-zinc-800">
          <mat-paginator [pageSizeOptions]="pageSizeOptions"
                         [pageSize]="pageSize"
                         class="bg-zinc-900 text-white">
          </mat-paginator>
        </div>
      }
    </div>
  </div>
</div>
  